import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/edit.svg'
import _imports_1 from '@/assets/icons/trash.svg'
import _imports_2 from '@/assets/icons/close.svg'
import _imports_3 from '@/assets/icons/upload-icon.svg'
import _imports_4 from '@/assets/icons/icon-plus.svg'
import _imports_5 from '@/assets/icons/star-slim.svg'


const _hoisted_1 = { class: "home-designs-view" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title-section" }
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_5 = {
  key: 0,
  class: "content"
}
const _hoisted_6 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_7 = {
  key: 1,
  class: "designs-table"
}
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "spinner"
}
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = { class: "modal-header" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = { class: "form-group half" }
const _hoisted_19 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_20 = { class: "form-group half" }
const _hoisted_21 = { class: "form-row" }
const _hoisted_22 = { class: "form-group third" }
const _hoisted_23 = { class: "form-group third" }
const _hoisted_24 = { class: "form-group third" }
const _hoisted_25 = { class: "form-group third" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "features-grid" }
const _hoisted_28 = ["id", "value"]
const _hoisted_29 = ["for"]
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "file-upload-section" }
const _hoisted_33 = {
  key: 0,
  class: "file-name"
}
const _hoisted_34 = {
  key: 1,
  class: "file-name"
}
const _hoisted_35 = {
  key: 0,
  class: "image-preview-container"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "facades-section" }
const _hoisted_38 = { class: "facades-header" }
const _hoisted_39 = { class: "section-label" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "empty-facades"
}
const _hoisted_42 = { class: "facade-item-header" }
const _hoisted_43 = { class: "facade-label" }
const _hoisted_44 = { class: "facade-actions" }
const _hoisted_45 = ["onClick", "title"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "facade-fields" }
const _hoisted_48 = { class: "form-group half" }
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { class: "form-group half" }
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = { class: "facade-upload" }
const _hoisted_53 = { class: "facade-upload-row" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onChange"]
const _hoisted_56 = {
  key: 0,
  class: "file-name"
}
const _hoisted_57 = {
  key: 1,
  class: "file-name"
}
const _hoisted_58 = {
  key: 0,
  class: "image-preview-container"
}
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "modal-actions" }
const _hoisted_61 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "title-main" }, "Home Designs", -1)),
          (!$setup.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.houseDesigns.length) + " design" + _toDisplayString($setup.houseDesigns.length !== 1 ? "s" : ""), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "button default primary",
          onClick: $setup.openCreateModal
        }, "+ Create Home Design")
      ]),
      (!$setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            ($setup.houseDesigns.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("p", null, "No home designs found for this estate", -1),
                  _createElementVNode("p", { class: "hint" }, "Create your first home design to get started", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("table", _hoisted_7, [
                  _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Design Name"),
                      _createElementVNode("th", null, "Size"),
                      _createElementVNode("th", null, "Configuration"),
                      _createElementVNode("th", null, "Actions")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.houseDesigns, (design) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: design._id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(design.name), 1),
                        _createElementVNode("td", null, _toDisplayString(design.area) + " sqm", 1),
                        _createElementVNode("td", null, _toDisplayString($setup.getConfiguration(design)), 1),
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("img", {
                            class: "icon-action",
                            src: _imports_0,
                            onClick: ($event: any) => ($setup.openEditModal(design)),
                            alt: "Edit"
                          }, null, 8, _hoisted_9),
                          _createElementVNode("img", {
                            class: "icon-action",
                            src: _imports_1,
                            onClick: ($event: any) => ($setup.confirmDelete(design)),
                            alt: "Delete"
                          }, null, 8, _hoisted_10)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
          ]))
        : _createCommentVNode("", true),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11))
        : _createCommentVNode("", true)
    ]),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _withModifiers($setup.closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h3", null, _toDisplayString($setup.isEditMode ? "Edit" : "Create") + " Home Design", 1),
              _createElementVNode("img", {
                class: "close-icon",
                src: _imports_2,
                onClick: $setup.closeModal,
                alt: "Close"
              })
            ]),
            _createElementVNode("form", {
              class: "modal-form",
              onSubmit: _withModifiers($setup.saveDesign, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_14, [
                _cache[13] || (_cache[13] = _createElementVNode("label", null, "Design Name *", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.name.$error }]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.name) = $event)),
                  placeholder: "e.g. Oakwood 250"
                }, null, 2), [
                  [_vModelText, $setup.form.name]
                ]),
                ($setup.v$.name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.v$.name.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[14] || (_cache[14] = _createElementVNode("label", null, "Design Overview", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  class: "input textarea",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.description) = $event)),
                  placeholder: "Describe the home design...",
                  rows: "4"
                }, null, 512), [
                  [_vModelText, $setup.form.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", null, "Size", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["input", { error: $setup.v$.area.$error }]),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.area) = $event)),
                    placeholder: "e.g. 250",
                    type: "number",
                    step: "any"
                  }, null, 2), [
                    [
                      _vModelText,
                      $setup.form.area,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  ($setup.v$.area.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.v$.area.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", null, "Configuration", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.configurationInput) = $event)),
                    placeholder: "e.g. 4 Bed / 2 Bath / 2 Car",
                    readonly: ""
                  }, null, 512), [
                    [_vModelText, $setup.configurationInput]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", null, "Bedrooms *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["input", { error: $setup.v$.bedroom.$error }]),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.bedroom) = $event)),
                    type: "number",
                    min: "0"
                  }, null, 2), [
                    [
                      _vModelText,
                      $setup.form.bedroom,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", null, "Bathrooms *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["input", { error: $setup.v$.bathroom.$error }]),
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.bathroom) = $event)),
                    type: "number",
                    min: "0"
                  }, null, 2), [
                    [
                      _vModelText,
                      $setup.form.bathroom,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", null, "Garage *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["input", { error: $setup.v$.garage.$error }]),
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.garage) = $event)),
                    type: "number",
                    min: "0"
                  }, null, 2), [
                    [
                      _vModelText,
                      $setup.form.garage,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", null, "Living *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["input", { error: $setup.v$.loungeRoom.$error }]),
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.loungeRoom) = $event)),
                    type: "number",
                    min: "0"
                  }, null, 2), [
                    [
                      _vModelText,
                      $setup.form.loungeRoom,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "section-label" }, "Features / Highlights", -1)),
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.availableFeatures, (feature) => {
                    return _createElementVNode("div", {
                      class: "feature-item",
                      key: feature
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: feature,
                        value: feature,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.features) = $event))
                      }, null, 8, _hoisted_28), [
                        [_vModelCheckbox, $setup.form.features]
                      ]),
                      _createElementVNode("label", { for: feature }, _toDisplayString(feature), 9, _hoisted_29)
                    ])
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _cache[22] || (_cache[22] = _createElementVNode("label", null, "Price", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form.basePrice) = $event)),
                  placeholder: "e.g. 350000",
                  type: "number"
                }, null, 512), [
                  [
                    _vModelText,
                    $setup.form.basePrice,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[24] || (_cache[24] = _createElementVNode("label", null, "Floor Plan", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("button", {
                    class: "button default outline",
                    type: "button",
                    onClick: $setup.triggerFloorPlanUpload
                  }, [
                    _cache[23] || (_cache[23] = _createElementVNode("img", {
                      class: "icon-upload",
                      src: _imports_3,
                      alt: "Upload"
                    }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString($setup.floorPlanFile ? "Change File" : $setup.isEditMode && $setup.form.floorplans.length > 0 ? "Replace File" : "Upload File"), 1)
                  ]),
                  _createElementVNode("input", {
                    ref: "floorPlanInput",
                    type: "file",
                    accept: "image/*,.pdf",
                    onChange: $setup.handleFloorPlanUpload,
                    style: {"display":"none"}
                  }, null, 544),
                  ($setup.floorPlanFile)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString($setup.floorPlanFile.name), 1))
                    : ($setup.isEditMode && $setup.form.floorplans.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Current file uploaded"))
                      : _createCommentVNode("", true)
                ]),
                ($setup.floorPlanPreviewUrl || ($setup.isEditMode && !$setup.floorPlanFile && $setup.form.floorplans.length > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("img", {
                        class: "image-preview",
                        src: $setup.floorPlanPreviewUrl || $setup.form.floorplans[0].url,
                        alt: "Floor Plan Preview"
                      }, null, 8, _hoisted_36)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, "Facades (" + _toDisplayString($setup.tempFacades.length) + "/5)", 1),
                  _createElementVNode("button", {
                    class: "button default outline small",
                    type: "button",
                    onClick: $setup.addFacade,
                    disabled: $setup.tempFacades.length >= 5
                  }, [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("img", {
                      class: "icon-plus",
                      src: _imports_4,
                      alt: "Add"
                    }, null, -1),
                    _createElementVNode("span", null, "Add Facade", -1)
                  ]))], 8, _hoisted_40)
                ]),
                ($setup.tempFacades.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, "No facades added. Click \"Add Facade\" to add one."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tempFacades, (facade, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "facade-item",
                    key: facade.tempId
                  }, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("span", _hoisted_43, "Facade " + _toDisplayString(index + 1), 1),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["button-icon default", { active: facade.isDefault }]),
                          type: "button",
                          onClick: ($event: any) => ($setup.setDefaultFacade(facade.tempId)),
                          title: facade.isDefault ? 'Default image' : 'Set as default image'
                        }, [
                          _createElementVNode("img", {
                            class: _normalizeClass(["icon-star", { filled: facade.isDefault }]),
                            src: _imports_5,
                            alt: "Star"
                          }, null, 2),
                          _createElementVNode("span", null, _toDisplayString(facade.isDefault ? "Default" : "Set Default"), 1)
                        ], 10, _hoisted_45),
                        _createElementVNode("button", {
                          class: "button-icon danger",
                          type: "button",
                          onClick: ($event: any) => ($setup.removeFacade(facade.tempId))
                        }, [...(_cache[26] || (_cache[26] = [
                          _createElementVNode("img", {
                            class: "icon-close",
                            src: _imports_2,
                            alt: "Remove"
                          }, null, -1)
                        ]))], 8, _hoisted_46)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _cache[27] || (_cache[27] = _createElementVNode("label", { class: "small-label" }, "Name *", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: "input small",
                          "onUpdate:modelValue": ($event: any) => ((facade.name) = $event),
                          placeholder: "e.g. Classic"
                        }, null, 8, _hoisted_49), [
                          [_vModelText, facade.name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "small-label" }, "Description", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: "input small",
                          "onUpdate:modelValue": ($event: any) => ((facade.description) = $event),
                          placeholder: "e.g. Traditional brick exterior"
                        }, null, 8, _hoisted_51), [
                          [_vModelText, facade.description]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("button", {
                          class: "button default outline small",
                          type: "button",
                          onClick: ($event: any) => ($setup.triggerFacadeUpload(facade.tempId))
                        }, [
                          _cache[29] || (_cache[29] = _createElementVNode("img", {
                            class: "icon-upload",
                            src: _imports_3,
                            alt: "Upload"
                          }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(facade.imageFile ? "Change" : facade.imagePath ? "Replace" : "Upload Image"), 1)
                        ], 8, _hoisted_54),
                        _createElementVNode("input", {
                          ref_for: true,
                          ref: (el) => ($setup.facadeInputRefs[facade.tempId] = el),
                          type: "file",
                          accept: "image/*",
                          onChange: ($event: any) => ($setup.handleFacadeUpload(facade.tempId, $event)),
                          style: {"display":"none"}
                        }, null, 40, _hoisted_55),
                        (facade.imageFile)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(facade.imageFile.name), 1))
                          : (facade.imagePath && !facade.imageFile)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, "Image uploaded"))
                            : _createCommentVNode("", true)
                      ]),
                      (facade.previewUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createElementVNode("img", {
                              class: "image-preview",
                              src: facade.previewUrl,
                              alt: "Facade Preview"
                            }, null, 8, _hoisted_59)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("button", {
                  class: "button default cancel",
                  type: "button",
                  onClick: $setup.closeModal
                }, "Cancel"),
                _createElementVNode("button", {
                  class: "button default primary",
                  type: "submit",
                  disabled: $setup.saving
                }, _toDisplayString($setup.saving ? "Saving..." : $setup.isEditMode ? "Save Changes" : "Create Design"), 9, _hoisted_61)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}